import selectComponent from 'utilities/select-component';
import CustomInput from 'component/CustomInput';

const baseClass = 'form';

export default class AjaxForm {
	completeClass = baseClass + '--is-complete';
	disabledClass = baseClass + '--is-disabled';
	activeClass = baseClass + '--is-active';
	loadingClass = baseClass + '--is-loading';
	fieldsSelector = '[data-component="input"]';
	inputs = {};

	constructor(element) {
		this.$form = selectComponent(element);

		this.buildInputs();
		this.createSuccessElement();

		this.$form
			.attr('novalidate', true)
			.on('submit', (...args) => this.handleSubmit(...args));
	}

	buildInputs() {
		$(this.$form.find(this.fieldsSelector).get().reverse()).each(
			(index, element) => {
				const input = new CustomInput(element);

				this.inputs[input.getName()] = input;
			}
		);
	}

	createSuccessElement() {
		if (!this.$form.elements.successMessage) {
			this.$form.append(
				$('<div />', {
					class: 'form__success',
					'data-element': 'success-message',
				})
			);

			this.$form.refresh();
		}
	}

	handleError(jqXHR) {
		const errorObject = jqXHR.responseJSON ? jqXHR.responseJSON.errors : false;

		if (errorObject) {
			$.each(errorObject, (key, value) => {
				if ($.type(value) === 'string') {
					value = [value][0];
				}
				if (!(key in this.inputs)) {
					key = key.replace('.', '[');
					key = key.replace('.', '][');
					key = key + ']';
				}
				this.inputs[key].setError(value.join('<br />'));
			});

			const $firstError = this.$form.find('.input__error').first();

			if ($firstError.length) {
				const inputName = $firstError.attr('for');
				this.inputs[inputName].$component.velocity('scroll', {
					offset: -200,
					duration: 350,
					complete: () => {
						this.$form.find(`#${inputName}`).focus();
					},
				});
			}
		}

		if (window.grecaptcha) {
			window.grecaptcha.reset();
		}
	}

	resetErrors() {
		$.each(this.inputs, (name, field) => field.removeError());
	}

	handleSuccess(data) {
		this.$form.addClass(this.completeClass);

		if (window.ga) {
			window.ga(
				'send',
				'event',
				'New form submission',
				window.location + ' form submitted'
			);
		}

		$.each(this.inputs, (name, field) => field.disable());

		this.$form.elements.submit.attr('disabled', 'disabled');

		var form_id = $('#display-form input[name=dynamic_form_id]').val();
		var contact_form = $('#contact-form').length;

		if (
			(form_id == 7 || contact_form > 0) &&
			typeof data.additional_information.email !== 'undefined'
		) {
			$.magnificPopup.open({
				items: {
					src: '#email-two-factor-modal',
				},
				type: 'inline',
			});

			var submission_id = data.additional_information.id;
			var created_at = data.additional_information.created_at;
			var email = data.additional_information.email;

			$('#email-two-factor-modal #submission_id').val(submission_id);
			$('#email-two-factor-modal #created_at').text(created_at);
			$('#email-two-factor-modal #email-input').val(email);
		} else {
			this.$form.elements.successMessage.append(
				$('<p />', {
					text: data.message,
				})
			);

			this.$form
				.velocity(
					{
						opacity: 0.8,
					},
					{
						duration: 1500,
						easing: 'easeOutCubic',
					}
				)
				.velocity(
					{
						opacity: 1,
					},
					{
						begin: () => {
							this.$form.elements.successMessage.velocity(
								'transition.slideUpIn',
								{
									complete: () => {
										this.$form.elements.successMessage.velocity('scroll', {
											offset: -200,
											duration: 350,
										});
									},
								}
							);
						},
						complete: () => {
							this.$form.removeAttr('styles');
						},
						duration: 750,
						easing: [1000, 20],
					}
				);

			if (this.$form.attr('data-msf-trigger')) {
				$(window).trigger(
					'multistep-form-submit',
					this.$form.attr('data-msf-trigger')
				);
			}

			if (this.$form.attr('data-ga') && window.ga) {
				const category = this.$form.attr('data-ga-category');
				const action = this.$form.attr('data-ga-action');
				const label = this.$form.attr('data-ga-label');

				window.ga('send', 'event', category, action, label);
			}
		}
	}

	handleRequestStart() {
		this.resetErrors();

		this.$form.elements.submit
			.attr('disabled', 'disabled')
			.addClass(this.loadingClass);

		this.$form.addClass(this.disabledClass);
	}

	handleRequestEnd() {
		this.$form.elements.submit
			.attr('disabled', false)
			.removeClass(this.loadingClass);

		this.$form.removeClass(this.disabledClass);
	}

	handleSubmit(event) {
		event.preventDefault();

		if (this.$form.hasClass(this.disabledClass)) {
			return;
		}

		const data = new FormData(this.$form[0]);
		const url = this.$form.attr('action');

		this.handleRequestStart();

		$.ajax({
			url,
			type: 'POST',
			data,
			processData: false,
			contentType: false,
		})
			.always((...args) => this.handleRequestEnd(...args))
			.then((...args) => this.handleSuccess(...args))
			.fail((...args) => this.handleError(...args));
	}
}
